export const SITE = {
  brand: "Kris Fin Care",
  tagline: "Insurance & Loans, handled with care",
  advisor: "Krishna Menon",
  phoneDisplay: "+91 94968 02177",
  phoneHref: "+919496802177",
  whatsapp: "919496802177",
  email: "krisfincare@gmail.com",
  address: "Kerala, India",
  facebook: "https://www.facebook.com/share/1BgypHCxgM/?mibextid=wwXIfr",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/27176613/pexels-photo-27176613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  medical: "https://images.pexels.com/photos/668300/pexels-photo-668300.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  motor: "https://images.unsplash.com/photo-1618642624018-a370cbf3cd80",
  commercial: "https://images.pexels.com/photos/358549/pexels-photo-358549.jpeg",
  pension: "https://images.pexels.com/photos/7243360/pexels-photo-7243360.jpeg",
  home: "https://images.pexels.com/photos/15743368/pexels-photo-15743368.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  advisor: "https://customer-assets-7cd3h4nn.emergentagent.net/job_protect-future-3/artifacts/hc5lbkg3_Krishna%20Menon.png",
};

export const TESTIMONIALS = [
  {
    name: "Harsha",
    detail: "Nurse · Trivandrum",
    video: "https://customer-assets-7cd3h4nn.emergentagent.net/job_protect-future-3/artifacts/e8jzl675_Testimonial%20Harsha%20Trivandrum%20Nurse.mp4",
    poster: "/media/testimonial-harsha.jpg",
  },
  {
    name: "Saigayathri",
    detail: "Client · Canada",
    video: "https://customer-assets-7cd3h4nn.emergentagent.net/job_protect-future-3/artifacts/lk9mndln_Testimonial%20Saigayathri%20canada.mp4",
    poster: "/media/testimonial-saigayathri.jpg",
  },
  {
    name: "Shinu Joseph",
    detail: "Bio-Chemist · Changanacherry",
    video: "/media/testimonial-new.mp4",
    poster: "/media/testimonial-new.jpg",
  },
];

export const SERVICES = [
  "Medical Insurance",
  "Life & Term Insurance",
  "Motor Insurance",
  "Pension Plans",
  "Home Loans",
  "Commercial Property Loans",
];
